import AdGroupPage from './AdGroupPage.vue'
import AdGroupEditor from './AdGroupEditor.vue'
import AdGroupSimpleEditor from './AdGroupSimpleEditor.vue'
import AdGroupForm from './AdGroupForm.vue'
import BannerPosition from './BannerPosition.vue'
import OperationButtons from './OperationButtons.vue'

export {
  AdGroupPage,
  AdGroupEditor,
  AdGroupSimpleEditor,
  AdGroupForm,
  BannerPosition,
  OperationButtons
}

export default {
  AdGroupPage,
  AdGroupEditor,
  AdGroupSimpleEditor,
  AdGroupForm,
  BannerPosition,
  OperationButtons
}
